import { HeartHandshake, Sparkles, Users } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1666865482301-05867408ffe9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjYXJpbmclMjBhZHVsdCUyMGFuZCUyMGNoaWxkJTIwd2FybSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3ODM5NTg2MDh8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div>
      <section className="border-b border-[hsl(var(--border))] bg-[hsl(var(--muted))]/50">
        <div className="container-cuidar py-16 grid gap-10 lg:grid-cols-[1.1fr_1fr] items-center">
          <div>
            <div className="text-xs font-semibold tracking-widest uppercase text-[hsl(var(--secondary))]">Sobre</div>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-black leading-tight">Um instituto que caminha com você.</h1>
            <p className="mt-5 text-lg text-[hsl(var(--muted-foreground))] leading-relaxed max-w-2xl">
              O Instituto Cuidar é um espaço de acolhimento, orientação e informação para famílias de crianças neuroatípicas — TEA, TDAH, dislexia, síndromes e outras neurodivergências. Nascemos da certeza de que ninguém deveria caminhar sozinho.
            </p>
          </div>
          <img src={HERO} alt="Cuidar é caminhar junto" className="w-full h-[380px] object-cover rounded-[2rem]" />
        </div>
      </section>

      <section className="container-cuidar py-16 grid gap-8 md:grid-cols-3">
        {[
          { icon: HeartHandshake, title: "Missão", text: "Oferecer suporte informacional, emocional e comunitário a famílias de crianças neuroatípicas em todo o Brasil." },
          { icon: Sparkles, title: "Visão", text: "Um país em que a neurodivergência é acolhida com respeito, ciência e afeto — desde a primeira infância." },
          { icon: Users, title: "Valores", text: "Escuta ativa, respeito à singularidade, ciência atualizada, gratuidade do primeiro acesso e comunidade." },
        ].map((b, i) => (
          <div key={b.title} className="surface p-7">
            <div className="grid h-11 w-11 place-items-center rounded-2xl bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))]"><b.icon className="h-5 w-5" /></div>
            <h3 className="mt-4 font-heading text-xl font-extrabold">{b.title}</h3>
            <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">{b.text}</p>
          </div>
        ))}
      </section>

      <section className="container-cuidar pb-20">
        <div className="surface p-8 sm:p-10">
          <h2 className="font-heading text-2xl sm:text-3xl font-extrabold">Como podemos ajudar sua família</h2>
          <div className="mt-6 grid gap-6 md:grid-cols-2">
            <ul className="space-y-3 text-sm">
              {["Pré-atendimento humano pelo WhatsApp", "Encaminhamento para profissionais parceiros", "Materiais de orientação para o dia a dia", "Grupos de apoio online"].map((t) => (
                <li key={t} className="flex items-start gap-3"><span className="mt-1 inline-block h-2 w-2 rounded-full bg-[hsl(var(--primary))]" />{t}</li>
              ))}
            </ul>
            <ul className="space-y-3 text-sm">
              {["Conteúdos revisados por especialistas", "Rede de apoio entre famílias", "Sensibilização de escolas", "Escuta gratuita nas primeiras conversas"].map((t) => (
                <li key={t} className="flex items-start gap-3"><span className="mt-1 inline-block h-2 w-2 rounded-full bg-[hsl(var(--secondary))]" />{t}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
